require ('./calendar.scss')
var moment = require('moment');

const calendar = require ('./calendar.html')
const day_title = require ('./day_title.html')
const slot_empty = require ('./slot-empty.html')
const slot_available = require ('./slot-available.html')

class AppointmentCalendarBuilder {

  constructor(calendarTarget, targetForm,slot_taken, morning_start,
              morning_stop, afternoon_start, afternoon_stop, working_days) {
    this.calendarTarget = calendarTarget;
    this.jCalendar =  $(calendar).clone();
    this.targetForm = targetForm
    this.slot_taken = slot_taken;
    this.morning_start = this.getHourValue(morning_start);
    this.morning_stop = this.getHourValue(morning_stop);
    this.afternoon_start = this.getHourValue(afternoon_start);
    this.afternoon_stop = this.getHourValue(afternoon_stop);
    this.working_days = working_days;
    this.working_days = [];
    working_days.forEach((e => {
      this.working_days.push(this.getDayValue(e));
    }));
  }

  setup() {

    this.weekNumber = 0;
    this.addDaysToCalendar();
    this.jCalendar.find("#next").on('click', () => {
      this.weekNumber = this.weekNumber + 1;
      this.addDaysToCalendar();
    });

    this.jCalendar.find("#previous").on('click', () => {
      if (this.weekNumber > 0) {
        this.weekNumber = this.weekNumber - 1;
        this.addDaysToCalendar();
      }
    });
    this.calendarTarget.html(this.jCalendar);
    this.setupConfirmation();
  }

  setupConfirmation() {
    this.jCalendar.find('#linkConfirmRdv').on('click', (e) => {
      e.preventDefault();

      this.targetForm.trigger("submit");

      return false;
    });
  }

  addDaysToCalendar() {
    var days = this.jCalendar.find(".availabilities-day")
    days.each((e, element) => {
      var title = $(day_title).clone();
      var focusedDay = moment().add(e + (this.weekNumber * 7), 'day');
      var dayString = focusedDay.date() + ' ' + this.getMonth(focusedDay)
      var year = focusedDay.year();
      var elem  = $(element);
      if (elem.find('.day-name').length !== 0 ) {
        elem.find(".day-name").html(this.getDay(focusedDay));
        elem.find(".day-number").html(dayString);
      } else {
        title.find(".day-name").html(this.getDay(focusedDay));
        title.find(".day-number").html(dayString);
        title.prependTo(element);
      }
      elem.find('.availabilities-slots').empty();
      this.addSlots(elem.find('.availabilities-slots'), dayString, year, focusedDay, e == 0);
    });

    days.find('.slot-available').each((i, target) => {
      $(target).on('click', () => {
        this.jCalendar.find('.slot-selected').removeClass('slot-selected');
        $( target ).addClass('slot-selected');
        this.targetForm.find("#meeting_starts_at").val($(target).data('datetime'));

        this.jCalendar.find('#confirm-content-phrase').html(
          `Vous avez sélectionné un rendez-vous le <strong>${$(target).attr('data-date')}</strong> à <strong>${$(target).html()}</strong>. Souhaitez-vous confirmer ce rendez-vous ?`
        );

        this.jCalendar.find('#linkConfirmRdv').attr('disabled', null);
      });
    });
  }

  days(month,year) {
    return new Date(year, month, 0).getDate();
 };

 getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

  isSlotTaken(momentBaseDate) {
    if (!this.working_days.includes(momentBaseDate.weekday()))
      return true
    var isTaken = false
    this.slot_taken.forEach((e) => {
      if(moment(e.slot_start).isSame(momentBaseDate)){
        isTaken = true
        return false;
      }
    });
    return isTaken;
  }

  addSlot(stringHour, moment, date, year, elem, isPassed){
    if(isPassed || this.isSlotTaken(moment))
      elem.append($(slot_empty).clone());
    else
      elem.append(this.getAvailableSlotHtml(stringHour, date, year, moment));
  }

  addSlots(elem, date, year, momentBaseDate, firstDay) {
    momentBaseDate.set({ minute: 0, second: 0, millisecond: 0});
    var current_hour = moment().hour();
    var start_morning_hour = this.morning_start;
    var start_afternoon_hour = this.afternoon_start;

    if (this.morning_start < current_hour) {
      start_morning_hour = current_hour;
    }


    if (this.afternoon_start < current_hour) {
      start_afternoon_hour = current_hour;
    }


    if (firstDay) {
      for (let i = this.morning_start; i < this.morning_stop;) {
        this.addSlot(this.getHourString(i), momentBaseDate.set({hour: i}), date, year, elem, i <= start_morning_hour);
        i++;
      }

      for (let i = this.afternoon_start; i < this.afternoon_stop;){
        this.addSlot(this.getHourString(i), momentBaseDate.set({hour: i}), date, year, elem, i <= start_afternoon_hour);
        i++;
      }
    } else {
      for (let i = this.morning_start; i < this.morning_stop;) {
        this.addSlot(this.getHourString(i), momentBaseDate.set({hour: i}), date, year, elem, false);
        i++;
      }

      for (let i = this.afternoon_start; i < this.afternoon_stop;){
        this.addSlot(this.getHourString(i), momentBaseDate.set({hour: i}), date, year, elem, false);
        i++;
      }
    }



  }

  getAvailableSlotHtml(hour, date, year, momentDate){
    var slot = $(slot_available).clone();
    slot.html(hour);
    slot.attr('data-date', date);
    slot.attr('data-year', year);
    slot.attr('data-datetime', momentDate.toISOString());

    return slot;
  }

  getMonth(date) {
    var month = date.month();
    if(month === 0)
      return 'Jan.'
    if(month === 1)
      return 'Fév.'
    if(month === 2)
      return 'Mar.'
    if(month === 3)
      return 'Avr.'
    if(month === 4)
      return 'Mai'
    if(month === 5)
      return 'Juin'
    if(month === 6)
      return 'Juil.'
    if(month === 7)
      return 'Aout'
    if(month === 8)
      return 'Sep.'
    if(month === 9)
      return 'Oct.'
    if(month === 10)
      return 'Nov.'
    if(month === 11)
      return 'Déc.'
  }

 getDay(date) {
    if(date.day() === 1)
      return 'lun'
    if(date.day() === 2)
      return 'mar'
    if(date.day() === 3)
      return 'mer'
    if(date.day() === 4)
      return 'jeu'
    if(date.day() === 5)
      return 'ven'
    if(date.day() === 6)
      return 'sam'
    if(date.day() === 0)
      return 'dim'
  }

  getHourValue(value) {
    switch (value) {
     case 'AM_0' : return 0; break;
     case 'AM_1' : return 1; break;
     case 'AM_2' : return 2; break;
     case 'AM_3' : return 3; break;
     case 'AM_4' : return 4; break;
     case 'AM_5' : return 5; break;
     case 'AM_6' : return 6; break;
     case 'AM_7' : return 7; break;
     case 'AM_8' : return 8; break;
     case 'AM_9' : return 9; break;
     case 'AM_10': return 10; break;
     case 'AM_11': return 11; break;
     case 'AM_12': return 12; break;
     case 'PM_1' : return 13; break;
     case 'PM_2' : return 13; break;
     case 'PM_3' : return 14; break;
     case 'PM_4' : return 16; break;
     case 'PM_5' : return 17; break;
     case 'PM_6' : return 18; break;
     case 'PM_7' : return 19; break;
     case 'PM_8' : return 20; break;
     case 'PM_9' : return 21; break;
     case 'PM_10': return 22; break;
     case 'PM_11': return 23; break;
     default: return 8; break;
    }
  }

  getDayValue(value) {
    switch (value) {
      case 'monday' : return 1; break;
      case 'tuesday' : return 2; break;
      case 'wednesday' : return 3; break;
      case 'thursday' : return 4; break;
      case 'friday' : return 5; break;
      case 'saturday' : return 6; break;
      case 'sunday' : return 0; break;
      default: return 0; break;
    }
  }

  getHourString(value){
    switch (value) {
      case  0: return "00h00"; break;
      case  1: return "1h00"; break;
      case  2: return "2h00"; break;
      case  3: return "3h00"; break;
      case  4: return "4h00"; break;
      case  5: return "5h00"; break;
      case  6: return "6h00"; break;
      case  7: return "7h00"; break;
      case  8: return "8h00"; break;
      case  9: return "9h00"; break;
      case  10: return "10h00"; break;
      case  11: return "11h00"; break;
      case  12: return "12h00"; break;
      case  13: return "13h00"; break;
      case  14: return "14h00"; break;
      case  15: return "15h00"; break;
      case  16: return "16h00"; break;
      case  17: return "17h00"; break;
      case  18: return "18h00"; break;
      case  19: return "19h00"; break;
      case  20: return "20h00"; break;
      case  21: return "21h00"; break;
      case  22: return "22h00"; break;
      case  23: return "23h00"; break;
      default: return "N/A"; break;
     }
  }
};

var buildAppointmentCalendar = function(form, slot_taken, morning_start, morning_stop,
                                        afternoon_start, afternoon_stop, working_days) {
  var builder = new AppointmentCalendarBuilder($(this), form, slot_taken, morning_start, morning_stop,
                                               afternoon_start, afternoon_stop, working_days);
  builder.setup();

  return builder;
};

export default buildAppointmentCalendar;
